export default function ImageFrame({ image, className = '', priority = false, onFocus }) {
  const title = image.title || `Frame ${String(image.index + 1).padStart(2, '0')}`;

  return (
    <figure
      className={`image-frame ${image.orientation || 'landscape'} ${className}`}
      style={image.style}
      data-orientation={image.orientation}
      data-depth={image.style?.['--depth'] || 1}
    >
      <button type="button" className="image-frame__button" onClick={() => onFocus?.(image)}>
        <img
          src={image.src}
          alt={title}
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          fetchPriority={priority ? 'high' : 'auto'}
        />
        <span className="image-frame__veil" aria-hidden="true" />
      </button>
      <figcaption>
        <span>{String(image.index + 1).padStart(2, '0')}</span>
        <span>{image.orientation}</span>
      </figcaption>
    </figure>
  );
}
